module.exports = __webpack_public_path__ + "static/img/test1.f746026.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test1.jpg
// module id = DIg1
// module chunks = 25